import { PayableReturn } from '../clients/rust-api-client';

export type PayableBadgeColor =
  | 'lime'
  | 'red'
  | 'amber'
  | 'zinc'
  | 'sky'
  | 'purple'
  | 'green';

/** Our status, as a badge colour. */
export const payableStatusColor = (status: string): PayableBadgeColor => {
  switch (status) {
    case 'pending':
      return 'amber';
    case 'settling':
      return 'sky';
    case 'settled':
      return 'green';
    case 'cancelled':
      return 'zinc';
    case 'failed':
    case 'returned':
      return 'red';
    default:
      return 'zinc';
  }
};

/** Our status, as a person reads it. */
export const payableStatusLabel = (p: PayableReturn): string => {
  switch (p.status) {
    case 'draft':
    case 'tokened':
    case 'adding':
      return 'Submitting';
    case 'pending':
      return 'Awaiting settle';
    case 'settling':
      return 'Settling';
    case 'settled':
      return p.bank_status === 'Complete' ? 'Complete' : 'Settled';
    case 'cancelled':
      return 'Cancelled';
    case 'failed':
      return 'Failed';
    case 'returned':
      return 'Returned';
    default:
      return p.status;
  }
};

/** "Payment to vendor" or "Collection from homeowner". */
export const payableDirectionLabel = (p: PayableReturn): string =>
  p.direction === 'collection' ? 'Collection' : 'Payment';

/** Sum of amounts as a number; amounts are decimal strings. */
export const sumAmounts = (items: PayableReturn[]): number =>
  items.reduce((t, p) => t + (Number(p.amount) || 0), 0);
